import * as MuiIcons from "@mui/icons-material";
import * as Mui from "@mui/material";
import { useTranslation } from "react-i18next";

interface Props {
    open: boolean;
    form?: any;
    title: string,
    body: string,
    leftButton: string,
    rightButton: string,
    viewNote?: boolean,
    leftFunction: () => void,
    rigthFunction: () => void;
    onClose: () => void;
}

const CardsModal = (props: Props) => {
    const { t } = useTranslation("finance", { keyPrefix: "payments.amex.cards" });

    const onClose = () => {
        props.onClose();
    };


    return (
        <Mui.Dialog
            open={props.open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    minWidth: "600px !important",
                    minHeight: "194px",
                    borderRadius: "4px",
                },
            }}
        >
            <Mui.DialogTitle>
                <Mui.Grid
                    container
                    alignItems="center"
                    alignContent="center"
                    direction="row"
                >
                    <Mui.Grid xs item>
                        <Mui.Stack direction="row" alignItems="center" gap={1}>
                            <MuiIcons.Info sx={{ color: '#C8017D' }} fontSize="small" />
                            <Mui.Box >{props.title}</Mui.Box>
                        </Mui.Stack>
                    </Mui.Grid>
                    <Mui.Grid
                        xs
                        item
                        sx={{
                            justifyContent: "flex-end",
                            display: "flex",
                        }}
                    >
                        <MuiIcons.Close
                            color="disabled"
                            fontSize="small"
                            onClick={onClose}
                        />
                    </Mui.Grid>
                </Mui.Grid>
            </Mui.DialogTitle>

                <Mui.Grid>

                    <Mui.DialogContent>
                        <Mui.DialogContentText>
                            {props.body}
                        </Mui.DialogContentText>
                    </Mui.DialogContent>
                    <Mui.DialogActions>
                        <Mui.Stack direction="row" spacing={2} p={1} mr={1}>
                            <Mui.Button
                                sx={{
                                    maxWidth: "111px",
                                    maxHeight: "48px",
                                    minWidth: "111px",
                                    minHeight: "48px",
                                }}
                                variant="outlined"
                                onClick={props.leftFunction}
                            >
                                <Mui.Typography
                                    sx={{
                                        textTransform: "capitalize",
                                        fontWeight: 700,
                                        lineHeight: 1.25,
                                        color: "#C8017D",
                                    }}
                                    variant="subtitle1"
                                >
                                    {props.leftButton}
                                </Mui.Typography>
                            </Mui.Button>

                            <Mui.Button
                                sx={{
                                    maxWidth: "181px",
                                    maxHeight: "48px",
                                    minWidth: "111px",
                                    minHeight: "48px",
                                }}
                                type={'button'}
                                variant="contained"
                                color="accent"
                                onClick={props.rigthFunction}
                            >
                                <Mui.Typography
                                    sx={{
                                        textTransform: "capitalize",
                                        fontWeight: 700,
                                        lineHeight: 1.25,
                                        color: 'white'
                                    }}
                                    variant="subtitle1"
                                >
                                    {props.rightButton}
                                </Mui.Typography>
                            </Mui.Button>
                        </Mui.Stack>
                    </Mui.DialogActions>
                </Mui.Grid>


        </Mui.Dialog>

    );
}

export default CardsModal;